import { Project } from "../stores/ProjectsStore";
import slugifyLib from '@sindresorhus/slugify';


export const slugify = (text: string): string => {
  if (!text || typeof text !== 'string') {
    return '';
  }
  
  return slugifyLib(text, {
    lowercase: true,
  });
};

export const getProjectIdFromSlug = (slug: string, projects: Project[]): string | null => {
  if (!isNaN(Number(slug))) {
    return slug;
  }
  
  const project = projects.find(p => slugify(p.title || p.name) === slug);
  return project ? String(project.id) : null;
};